<script setup lang="ts">
const { locale, t } = useI18n();
provide(
  'r3ui-custom-input-clear-label',
  computed(() => t('custom_input.clear'))
);
const i18nHead = useLocaleHead();
provide(
  'r3ui-custom-input-mask-labels',
  computed(() => ({
    loading: t('table_pagination.loading'),
    error: t('pages.errors.unexpected'),
    retry: t('pages.retry'),
  }))
);

useHead(() => ({
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs?.lang || locale.value,
    dir:
      i18nHead.value.htmlAttrs?.dir || (locale.value === 'he' ? 'rtl' : 'ltr'),
  },
}));
</script>

<template>
  <NuxtLayout>
    <NuxtPage :keepalive="true" />
  </NuxtLayout>
</template>

<style></style>
